<template>
  <v-icon large :color="color">mdi-checkbox-blank-circle</v-icon>
</template>

<script>
const STATUS_COLOR = {
  BOM: 'success',
  MEDIANO: 'amber',
  RUIM: 'error',
  PESSIMO: 'purple',
  DEFAULT: 'amber',
};

export default {
  props: {
    status: String,
  },
  computed: {
    color() {
      if (!this.status) {
        return STATUS_COLOR.DEFAULT;
      }
      return STATUS_COLOR[this.status];
    },
  },
};
</script>
